import { NotificationDefinition } from '../../types'
import { QuotePdfGenerationTimeoutHeader } from './QuotePdfGenerationTimeoutHeader'
import { QuotePdfGenerationTimeoutListItem } from './QuotePdfGenerationTimeoutListItem'
import { QuotePdfGenerationTimeoutPreview } from './QuotePdfGenerationTimeoutPreview'

export const quotePdfGenerationTimeoutDefinition: NotificationDefinition = {
  listItemContent: QuotePdfGenerationTimeoutListItem,
  previewHeaderContent: QuotePdfGenerationTimeoutHeader,
  previewContent: QuotePdfGenerationTimeoutPreview
}
